export function formatDateToInputFormat(date: Date) {
  return date.toISOString().slice(0, 10)
}
